import { render, staticRenderFns } from "./theory.vue?vue&type=template&id=cda1cd56&scoped=true&"
import script from "./theory.vue?vue&type=script&lang=js&"
export * from "./theory.vue?vue&type=script&lang=js&"
import style0 from "./theory.vue?vue&type=style&index=0&id=cda1cd56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda1cd56",
  null
  
)

export default component.exports